import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms.tsx'
import {XCloseIcon} from '@/components/ui/icon/Icon.tsx'
import {useTranslation} from '@/translations/i18n.tsx'
import {Access} from '../../types'
import {useUpdateAccess} from '../../queries/useUpdateAccess'
import {toast} from '@/utilities/toast/toast'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {MUTATION_KEYS, QUERY_KEYS} from '@/queryClient'
import {useIsMutating, useQueryClient} from '@tanstack/react-query'

export const InvalidateAccessButton = ({access}: {access: Access}) => {
    const {t} = useTranslation()
    const queryClient = useQueryClient()
    const {mutate: updateAccess, isPending: isUpdating} = useUpdateAccess(
        {accessId: access.id},
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES]})
                toast.success(t('accesses:access_invalidated_success'))
            }
        }
    )
    const isMutating = useIsMutating({mutationKey: [MUTATION_KEYS.UPDATE_ACCESS, access.id]})

    return (
        <MenuItem
            hideOnClick={false}
            disabled={isUpdating || isMutating > 0}
            onClick={e => {
                e.stopPropagation()
                e.preventDefault()
                updateAccess({
                    status: 'to_validate'
                })
            }}
        >
            {isUpdating ? <Spinner /> : <XCloseIcon />}
            {t('accesses:invalidate_access')}
        </MenuItem>
    )
}
